import { orchestrator } from 'satcheljs';
import populatePublicFolderOutlookFavoriteStore from '../actions/populatePublicFolderOutlookFavoriteStore';
import {
    OutlookFavoriteServiceDataType,
    FavoritePublicFolderData,
    FavoriteDataClient,
} from 'owa-favorites-types';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    favoritesStore,
    addFavoriteToStoreInitial,
    getSingleValueSettingValueForKey,
} from 'owa-favorites';
import publicFolderFavoriteStore from '../store/publicFolderFavoriteStore';

export default orchestrator(populatePublicFolderOutlookFavoriteStore, async actionMessage => {
    const outlookFavorites = getUserConfiguration().Favorites
        ? getUserConfiguration().Favorites.value
        : null;

    if (!outlookFavorites) {
        // Nothing to populate
        return;
    }

    outlookFavorites.forEach((serviceData: OutlookFavoriteServiceDataType) => {
        const isPublicFolderSetting = getSingleValueSettingValueForKey(
            serviceData,
            'IsPublicFolder'
        );

        if (
            serviceData.Type.toLowerCase() === 'folder' &&
            isPublicFolderSetting &&
            isPublicFolderSetting.toLowerCase() === 'true'
        ) {
            const favoriteData: FavoritePublicFolderData = {
                treeType: 'favorites',
                favoriteId: serviceData.Id,
                type: 'publicFolder',
                displayName: serviceData.DisplayName,
                publicFolderId: getSingleValueSettingValueForKey(serviceData, 'FolderId'),
                client: serviceData.Client as FavoriteDataClient,
                lastModifiedTime: serviceData.LastModifiedTime,
            };

            tryAddSingleFavoritePublicFolderToStore(favoriteData);
        }
    });
});

function tryAddSingleFavoritePublicFolderToStore(favoriteData: FavoritePublicFolderData) {
    if (shouldAddFavoritePublicFolder(favoriteData)) {
        addFavoriteToStoreInitial(favoriteData);
    }
}

/**
 * Should add public folder to favorite list
 */
function shouldAddFavoritePublicFolder(favoriteData: FavoritePublicFolderData): boolean {
    if (publicFolderFavoriteStore.folderTable.size === 0) {
        // Do not add the folder if the folder store hasn't been initiated yet
        return false;
    }

    return (
        !favoritesStore.outlookFavorites.has(favoriteData.favoriteId) &&
        publicFolderFavoriteStore.folderTable.has(favoriteData.publicFolderId)
    );
}
